import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { billableMetricsMessages } from 'src/features/billableMetrics/utils/messages';
import { AGGREGATION_TYPE, MEASUREMENT_TYPE } from 'src/features/billableMetrics/utils/types';

/**
 * The backend rejects a mismatched pair with `400 invalid_aggregation_for_measurement_type`.
 * UNIQUE_COUNT is in neither list on purpose - it always 400s.
 */
export const VALID_AGGREGATIONS_BY_MEASUREMENT: Record<MEASUREMENT_TYPE, AGGREGATION_TYPE[]> = {
    [MEASUREMENT_TYPE.STATEFUL]: [
        AGGREGATION_TYPE.TIME_WEIGHTED,
        AGGREGATION_TYPE.END_OF_PERIOD,
        AGGREGATION_TYPE.MAX_IN_PERIOD,
    ],
    [MEASUREMENT_TYPE.METERED]: [
        AGGREGATION_TYPE.COUNT,
        AGGREGATION_TYPE.SUM,
        AGGREGATION_TYPE.MAX,
        AGGREGATION_TYPE.LATEST,
    ],
};

export const MEASUREMENT_TYPE_MAP: Record<MEASUREMENT_TYPE, { id: string; defaultMessage: string }> = {
    [MEASUREMENT_TYPE.STATEFUL]: billableMetricsMessages.stateful,
    [MEASUREMENT_TYPE.METERED]: billableMetricsMessages.metered,
};

/*
 * UNIQUE_COUNT has to be present because this is a Record over the whole enum, but it is never
 * rendered - the value cannot be selected and no seeded metric uses it.
 */
export const AGGREGATION_TYPE_MAP: Record<AGGREGATION_TYPE, { id: string; defaultMessage: string }> = {
    [AGGREGATION_TYPE.TIME_WEIGHTED]: billableMetricsMessages.timeWeighted,
    [AGGREGATION_TYPE.END_OF_PERIOD]: billableMetricsMessages.endOfPeriod,
    [AGGREGATION_TYPE.MAX_IN_PERIOD]: billableMetricsMessages.maxInPeriod,
    [AGGREGATION_TYPE.COUNT]: billableMetricsMessages.count,
    [AGGREGATION_TYPE.SUM]: billableMetricsMessages.sum,
    [AGGREGATION_TYPE.MAX]: billableMetricsMessages.max,
    [AGGREGATION_TYPE.LATEST]: billableMetricsMessages.latest,
    [AGGREGATION_TYPE.UNIQUE_COUNT]: billableMetricsMessages.count,
};

export const MEASUREMENT_TYPE_BADGE_OPTIONS: Record<MEASUREMENT_TYPE, BadgeOption> = {
    [MEASUREMENT_TYPE.STATEFUL]: {
        label: billableMetricsMessages.stateful,
        theme: 'indigo',
        icon: ICON_MAP.CURRENT,
    },
    [MEASUREMENT_TYPE.METERED]: {
        label: billableMetricsMessages.metered,
        theme: 'cyan',
        icon: ICON_MAP.WAVE_PULSE,
    },
};
